import { Map } from 'immutable';
import { V1_CHALLENGE_PROCESS } from '@americanexpress/gravity-core';

let baseApiUrl;

export const getOneAppConfig = (state) => (Map.isMap(state) ? state.get('config') : state.config);

const getPayAuthApiUrl = (state) => getOneAppConfig(state).get(baseApiUrl);
const getDataHeader = (state) => state.getIn(['modules', 'axp-gravity-root', 'rootReducer', 'dataHeader']);
const getTransactionData = (state, params) => {
  const queryParams = state.getIn(['modules', 'axp-gravity-root', 'rootReducer', 'acsTransId']);
  const acsTransId = queryParams.acsTransId || params.get('acs-trans-id');
  const inauth = queryParams.inauth || params.get('inauth');
  const token = queryParams.token || params.get('token');

  return { acsTransId, inauth, token };
};

const getOS = () => {
  const version = window.navigator.appVersion;
  if (version.indexOf('Win') !== -1) return 'Windows';
  if (version.indexOf('Mac') !== -1) return 'MacOS';
  if (version.indexOf('X11') !== -1) return 'UNIX';
  if (version.indexOf('Linux') !== -1) return 'Linux';
  return 'Unknown';
};

const bTypes = [
  { type: 'Opera', offset: 8, label: 'Opera' },
  { type: 'MSIE', offset: 5, label: 'Microsoft Internet Explorer' },
  { type: 'Chrome', offset: 7, label: 'Chrome' },
  { type: 'Safari', offset: 7, label: 'Safari' },
  { type: 'Firefox', offset: 8, label: 'Firefox' },
];

const getBrowserInfo = () => {
  const { appName, appVersion, userAgent } = window.navigator;
  let bName = appName || 'Unknown';
  let bVersion = appVersion || 'Unknown';

  let match = false;
  bTypes.forEach((browser) => {
    let vIndex = userAgent.indexOf(browser.type);
    if (vIndex !== -1 && !match) {
      if (browser.type === 'Safari' && userAgent.indexOf('Version') !== -1) {
        // verify version doesn't exist otherwise change offset
        vIndex = userAgent.indexOf('Version') + 1;
      }
      bVersion = userAgent.slice(Math.max(0, vIndex + browser.offset));
      match = true;
      bName = browser.label;
    }
  });

  return {
    name: bName,
    version: bVersion,
  };
};

export const areCookiesEnabled = () => {
  const { cookieEnabled } = window.navigator;
  if (cookieEnabled) return true;
  window.document.cookie = 'testcookie';
  return window.document.cookie.indexOf('testcookie') !== -1;
};

export const fetchProcessPayAuth = (state) => {
  const { search } = window.location;
  const params = new URLSearchParams(search);
  const defaultLanguage = window.navigator.language || window.navigator.userLanguage;
  const browserLanguage = defaultLanguage && defaultLanguage.split('-');
  const mockEnabled = params.get('mockEnabled');
  const { acsTransId, inauth, token } = getTransactionData(state, params);
  const baseApi = `${mockEnabled === 'Y' ? 'mockProcessPayAuthApiUrl' : 'gravityCheckoutUrl'}`;
  const bInfo = getBrowserInfo();
  baseApiUrl = baseApi;

  const headerConfigBase = {
    Accept: 'application/json',
    'Content-Type': 'application/json',
    'browser-language': browserLanguage[0] || '',
    'acs-trans-id': acsTransId,
    Authorization: token,
    'Cache-Control': 'no-cache',
  };

  const dataHeader = getDataHeader(state);
  if (dataHeader) headerConfigBase.data = dataHeader;

  const headerConfigAuth = {
    height: window.screen.height,
    width: window.screen.width,
    browser: `${bInfo.name} ${bInfo.version}`,
    osname: getOS(),
    useragent: window.navigator.userAgent,
    timezone: new Date().getTimezoneOffset(),
    'cookies-enabled': areCookiesEnabled(),
  };
  const headerConfig = inauth === 'true'
    ? {
      ...headerConfigBase,
      ...headerConfigAuth,
    }
    : {
      ...headerConfigBase,
    };

  const url = `${getPayAuthApiUrl(state)}${V1_CHALLENGE_PROCESS}${mockEnabled === 'Y' ? '/mock' : ''}`;
  return {
    url,
    opts: {
      method: 'GET',
      headers: headerConfig,
      credentials: 'include',
      crossDomain: true,
    },
  };
};
